exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-btn-group {\n  min-width: 160px;\n}\n@media (max-width: 576px) {\n.action-btn-group {\n    justify-content: center;\n}\n}", ""]);

// exports
exports.locals = {
	"primary": "#aa4121",
	"secondary": "#ccc",
	"gray": "#636363"
};